import { jsxs as l, Fragment as o, jsx as e } from "react/jsx-runtime";
const d = () => /* @__PURE__ */ l(o, { children: [
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.25 16.75V17C2.25 18.5188 3.48122 19.75 5 19.75L19 19.75C20.5188 19.75 21.75 18.5188 21.75 17V16.75L2.25 16.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.26772 15.25C4.25604 15.1683 4.25 15.0849 4.25 15V5.5C4.25 4.80964 4.80964 4.25 5.5 4.25H18.5C19.1904 4.25 19.75 4.80964 19.75 5.5V15C19.75 15.0849 19.744 15.1684 19.7323 15.25L4.26772 15.25Z",
      fill: "currentColor"
    }
  )
] });
export {
  d as default
};
